import type { PostListItem } from '@/entities/post/types';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import type { SortOption } from '../../../entities/post/api/index';

export type ReferencedPostsResponse = {
  title: string;
  posts: PostListItem[];
  query_name: string;
  post_count: number;
};

export type ReferencedPostsParams = {
  session_id: string;
  block_id: string;
  answer_id: string;
  parts: 'overview' | 'theme';
  part_id: string;
  limit: number;
  order: SortOption;
};

export const fetchReferencedPosts = async (params: ReferencedPostsParams, signal?: AbortSignal) => {
  const { session_id, block_id, answer_id, parts, part_id, limit, order } = params;
  const response = await socialApiClient.post<ReferencedPostsResponse>(
    `sessions/${session_id}/blocks/${block_id}/posts`,
    {
      json: {
        answer_id,
        parts,
        part_id,
        limit,
        order,
      },
      signal,
    },
  );
  return response.json();
};
